import React from "react";
import { FormattedDateTimeRange, FormattedDate } from "react-intl";
import PropTypes from "prop-types";
import useStyles from "./dateRangeStyles";
import SrButton from "../SrButton";
import translate from "../../../i18n/translate";

export const displayDate = (startDate, endDate) => {
  if (startDate && endDate) {
    return <FormattedDateTimeRange from={startDate} to={endDate} />;
  }

  if (startDate || endDate) {
    return <FormattedDate value={startDate || endDate} />;
  }

  return null;
};

const CalendarFooter = ({
  startDate,
  endDate,
  closeHandler,
  dateSelectedHandler,
}) => {
  const classes = useStyles();
  const isDisabled = !(startDate && endDate);

  return (
    <div className={classes.calendarFooter}>
      <span className={classes.footerItem}>
        {displayDate(startDate, endDate)}
      </span>
      <SrButton
        className={classes.footerItem}
        variant="contained"
        onClick={closeHandler}
        size="small"
      >
        {translate("common.erase")}
      </SrButton>
      <SrButton
        className={classes.footerItem}
        color="primary"
        variant="contained"
        size="small"
        onClick={dateSelectedHandler}
        disabled={isDisabled}
      >
        {translate("common.applyAlt")}
      </SrButton>
    </div>
  );
};

CalendarFooter.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  dateSelectedHandler: PropTypes.func.isRequired,
};

export default CalendarFooter;
